export default __webpack_public_path__ + "faa87c1fea23090064c54f4e9d30e6e6.svg";